import './StatBlock.css';

const formatNumber = (n) => {
  if (n === null || n === undefined) return '—';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
};

const StatBlock = ({ label, value, icon, tone }) => {
  return (
    <div className={`stat-block ${tone ? `stat-block-${tone}` : ''}`}>
      {icon && <div className="stat-block-icon">{icon}</div>}
      <div className="stat-block-text">
        <div className="stat-block-value">{formatNumber(value)}</div>
        <div className="stat-block-label">{label}</div>
      </div>
    </div>
  );
};

export default StatBlock;
export { formatNumber };
